import React from "react"
import { useNavigate } from "react-router-dom"
import "./PartnersSection.css"

// Import all partner images
import tata from "../../images/tata.png"
import leyland from "../../images/leyland.png"
import mahindra from "../../images/mahindra.png"
import eicher from "../../images/eicher.png"
import man from "../../images/man.png"
import mercedes from "../../images/merc.png"
import volvo from "../../images/volvo.png"
import scania from "../../images/scania.png"
import renault from "../../images/renault.png"
import daf from "../../images/daf.png"
import mitsubishi from "../../images/mitsubishi.png"
import ford from "../../images/ford.png"
import toyota from "../../images/toyota.png"
import volkswagen from "../../images/volkswagen.png"
import jcb from "../../images/jcb.png"

const PartnersSection = () => {
  const navigate = useNavigate()

  const partners = [
    { name: "Tata", image: tata },
    { name: "Leyland", image: leyland },
    { name: "Mahindra", image: mahindra },
    { name: "Eicher", image: eicher },
    { name: "Man", image: man },
    { name: "Mercedes", image: mercedes },
    { name: "Volvo", image: volvo },
    { name: "Scania", image: scania },
    { name: "Renault", image: renault },
    { name: "DAF", image: daf },
    { name: "Mitsubishi Otobus", image: mitsubishi },
    { name: "Ford", image: ford },
    { name: "Toyota", image: toyota },
    { name: "Volkswagen", image: volkswagen },
    { name: "JCB", image: jcb },
  ]

  const handlePartnerClick = () => {
    navigate("/products")
  }

  return (
    <section className="partners-section section">
      <div className="container">
        <div className="partners-header">
          <h2 className="section-title">Trusted Replacement Parts Solutions for Leading Brands</h2>
          <p className="partners-subtitle">We proudly serve the automotive industry's most respected manufacturers</p>
        </div>
        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="partner-card"
              onClick={handlePartnerClick}
              title={`View ${partner.name} products`}
            >
              <div className="partner-logo">
                <img
                  src={partner.image || "/placeholder.svg"}
                  alt={`${partner.name} logo`}
                  className="partner-image"
                  loading="lazy"
                />
              </div>
              <div className="partner-name">{partner.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default PartnersSection